import emma from '@/common/services/Emma'

const ChatResource = {
	getThreads () { return emma.get('api/threads') },
	newThread (data) { return emma.post('api/messages', data) },
	newMessage (data) { return emma.post('api/messages', data) },
	appointmentRequest (data) { return emma.post('api/appointment-request', data, 'application/json') }
}

export default ChatResource



// WEBPACK FOOTER //
// ./src/common/resources/Chat.js